import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DoctorsScheduleApi } from '../api/doctors-schedule.api';
import { switchMap, map } from 'rxjs/operators';
import { DoctorsScheduleData, DoctorsSchedule } from '../../../interfaces/patient-services/doctors-schedule';

@Injectable()
export class DoctorsScheduleService extends DoctorsScheduleData {

  constructor(private api: DoctorsScheduleApi) {
    super();
  }


  list(url: string): Observable<DoctorsSchedule[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<DoctorsSchedule>{
      return this.api.getById(url);
  }

  create(url: string, data:DoctorsSchedule[]): Observable<DoctorsSchedule> {
    return this.api.add(url,data);
  }

  bulkUpdate(url: string, data:DoctorsSchedule[]): Observable<DoctorsSchedule> {
    return this.api.add(url,data);
  }

  update(url: string, data:DoctorsSchedule): Observable<DoctorsSchedule> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
